import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  company_details: {
    company_id: 0,
    maintenance_mode: {
      enabled: false,
      message: ""
    },
    user_name: "",
    user_id: null as number | null,
    time_zone_offset: "+00:00",
    is_admin_user: false,
    demo_account: false,
    ask_vantage_enabled: false,
    classic_dashboard_enabled: false,
    ask_vantage_v2_enabled: false,
    ask_vantage_v2_streaming_enabled: true,
    email: '',
    enable_clickhouse: false,
    plan_type: 'lite' as 'lite' | 'pro',
    max_lookback_days: 734,
    max_selection_days: 367 as number | null,
    // Sapaad Signals visibility mirrors `/api/v1/me`. Disabled keeps the
    // feature hidden until the server says otherwise.
    signals_status: 'disabled' as 'enabled' | 'coming_soon' | 'disabled'
  },
  shouldUseEpocForTimeRange: true,
  isAdminUser: false
};

const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setCompany(state, action) {
      state.company_details = action.payload;
      if (!action.payload.maintenance_mode.enabled) {
        state.company_details.maintenance_mode.message = "";
      }
    },
    setIsAdminUser(state, action) {
      state.isAdminUser = action.payload;
    }
  }
});

export const { setCompany, setIsAdminUser } = companySlice.actions;
export const reducer = companySlice.reducer;
